<template>
    <template
        v-if="params && !disableLink && params.youtubeId"
    >
        <!-- Video Link -->
        <VideoDialog :video-id="params.youtubeId">
            <template #default="{ props }">
                <v-btn
                    class="btn-universal btn-universal-video"
                    color="secondary"
                    v-bind="{...props, ...attrs}"
                    @click.stop.prevent
                >
                    <slot></slot>
                    <v-icon class="ml-2" size="large" :icon="mdiPlayCircle"></v-icon>
                </v-btn>
            </template>
        </VideoDialog>
    </template>

    <template
        v-else-if="params && !disableLink && params.url && plainLink"
    >
        <!-- Normal Link (href w/target) -->
        <a
            v-bind="$attrs"
            class="btn-universal btn-universal-href"
            :target="params.target"
            :href="params.url"
        >
            <slot></slot>
        </a>
    </template>

    <template
        v-else-if="params && !disableLink && params.url && !plainLink"
    >
        <!-- Vuetify Link (href w/target) -->
        <v-btn
            v-bind="$attrs"
            class="btn-universal btn-universal-href"
            :target="params.target"
            :href="params.url"
        >
            <slot></slot>
        </v-btn>
    </template>

    <template
        v-else-if="params && !disableLink && params.path && nuxtLink"
    >
        <!-- Nuxt Link (path) -->
        <NuxtLink
            class="btn-universal btn-universal-nuxt"
            :to="params.path"
            v-bind="$attrs"
        >
            <slot></slot>
        </NuxtLink>
    </template>

    <template
        v-else-if="params && !disableLink && params.path && !isNestedLink && !nuxtLink"
    >
        <!-- Nuxt Link (path) -->
        <v-btn
            v-bind="$attrs"
            class="btn-universal btn-universal-nuxt"
            :to="params.path"
            nuxt
        >
            <slot></slot>
        </v-btn>
    </template>

    <template
        v-else-if="params && !disableLink && params.path && isNestedLink && !nuxtLink"
    >
        <!-- Simulated / Nested Button -->
        <!-- Prevents "DOM tree is not matching" if nesting this button in another button/hyperlink -->
        <div
            v-bind="$attrs"
            class="btn-universal btn-universal-sim v-btn v-theme--light v-btn--density-default rounded-md v-btn--size-default v-btn--variant-flat"
        >
            <span class="v-btn__overlay"></span>
            <span class="v-btn__underlay"></span>
            <span class="v-btn__content" data-no-activator="">
                <slot></slot>
            </span>
        </div>
    </template>

    <template
        v-else-if="disableLink"
    >
        <!-- No Link -->
        <div
            v-bind="$attrs"
            class="btn-universal btn-universal-no-link"
        >
            <slot></slot>
        </div>
    </template>

    <template
        v-else
    >
        <!-- Error -->
        <div
            v-bind="$attrs"
            class="btn-universal btn-universal-error viz-hidden"
        >
            Misconfigured Button
        </div>
    </template>
</template>

<script lang="ts" setup>
    import type { ContentLink } from '~/types';
    import VideoDialog from '~/components/video/VideoDialog/VideoDialog.vue';
    import { mdiPlayCircle } from '@mdi/js';

    defineOptions({
        inheritAttrs: false
    });

    defineProps<{
        params: Nilish<ContentLink>;
        plainLink?: boolean;
        disableLink?: boolean;
        isNestedLink?: boolean;
        nuxtLink?: boolean;
    }>();

    const attrs = useAttrs();
</script>

<style lang="scss" scoped></style>
